import { render, staticRenderFns } from "./BetgameWelcome.vue?vue&type=template&id=4b9ccef7"
import script from "./BetgameWelcome.vue?vue&type=script&lang=js"
export * from "./BetgameWelcome.vue?vue&type=script&lang=js"
import style0 from "./BetgameWelcome.vue?vue&type=style&index=0&id=4b9ccef7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports